import { CommonModule } from '@angular/common';
import { Component, input, output, signal } from '@angular/core';
import { Checkbox } from '../../../checkbox/checkbox.component';
import { Icon } from '../../../icon/icon.component';
import { SelectGroupOptionComponent } from '../select-group-option/select-group-option.component';
import { SelectGroupItem } from '../select-group.component';
import { SelectHelper } from '../../select.hepler';

@Component({
  selector: 'app-select-group-wrapper',
  templateUrl: './select-group-wrapper.component.html',
  styleUrls: ['./select-group-wrapper.component.scss'],
  standalone: true,
  imports: [CommonModule, Icon, Checkbox, SelectGroupOptionComponent],
})
export class SelectGroupWrapperComponent {
  values = input<string[] | string>();

  valuesChange = output<string[] | string>();
  item = input<SelectGroupItem>();
  bindLabel = input<string>();
  bindValue = input<string>();
  open = signal(true);

  toggle(ev: any) {
    ev.stopPropagation();
    ev.preventDefault();
    this.open.set(!this.open());
  }

  handleClick(ev: any) {
    ev.stopPropagation();
    ev.preventDefault();
  }

  handleCheck(ev: boolean, option: any) {
    const value = SelectHelper.get(option, this.bindValue() || '');

    if (typeof this.values() === 'string') {
      if (ev) {
        this.valuesChange.emit(value);
      } else {
        this.valuesChange.emit('');
      }
    } else {
      if (ev) {
        this.valuesChange.emit([...(this.values() || []), value]);
      } else {
        this.valuesChange.emit(
          (this.values() as any[]).filter((v) => v !== value),
        );
      }
    }
  }

  handleAllCheck(ev: boolean) {
    if (ev) {
      this.valuesChange.emit(
        this.item()?.options.map((o) =>
          SelectHelper.get(o, this.bindValue() || ''),
        ) || [],
      );
    } else {
      this.valuesChange.emit([]);
    }
  }
}
